module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-SemiBold-9cf6cc81a1bab2cb898945c585062734.eot";